import React, { ReactElement, Component, useState, useEffect, useContext, useRef, Dispatch, SetStateAction, useMemo } from "react";
import "core-js/es/promise";
import "./App.less";
import "antd/dist/antd.css";
import "react-circular-progressbar/dist/styles.css";
import { Layout } from "antd";
import LeftMenu from "./components/left-menu/left-menu";
import { ThemeContext } from "./contexts/theme";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Global from "./pages/global/global";
import WorkspacesList from "./pages/workspaces-list/workspaces-list";
import ClustersList from "./pages/clusters/clusters-list";
import QuotaManagement from "./pages/quota-management/quota-management";
import MonitorManagement from "./pages/monitor/monitor-management";
import QuotaList from "./pages/quota-management/quota_list";
import { MultiSelectedContext } from "./contexts/multi-selected";
import { ButtonHideContext } from "./contexts/button-hide";
import ClusterInfo from "./pages/clusters/cluster-info";
import { WorkspaceInfo } from "./pages/workspace-info/workspace-info";
import { NamespaceInfo } from "./pages/namespace-info/namespace-info";
import NamespaceOverview from "./pages/namespace-overview/namespace-overview";
import { IngressInfo } from "./pages/ingress/ingress-info";
import Ingress from "./pages/ingress/ingress";
import { AlertManagement } from "./pages/alert-management/alert-management";
import { Monitor } from "./pages/monitor/monitor";
import NodesManagement from "./pages/nodes-management/nodes-management";
import QuotaScale from "./pages/workspaces-list/quota_scale";
import Applications from "./pages/applications/applications";
import ApplicationsDetail from "./pages/applications/applications-detail";
import StorageInfo from './pages/persistent-volume/storage-info';
import StorageClass from './pages/persistent-volume/storage-class';
import PV from './pages/persistent-volume/pv';
import PVC from './pages/persistent-volume/pvc';
import en_US from './i18n/en-US';
import zh_TW from './i18n/zh-TW';
import zh_CN from './i18n/zh-CN';
// import en_US_lite from './i18n/splitted/en-US-mp-lite-portal';
// import zh_TW_lite from './i18n/splitted/zh-TW-mp-lite-portal';
// import zh_CN_lite from './i18n/splitted/zh-CN-mp-lite-portal';
// import en_US_service from './i18n/splitted/en-US-ensaas-service-mesh-portal';
// import zh_TW_service from './i18n/splitted/zh-TW-ensaas-service-mesh-portal';
// import zh_CN_service from './i18n/splitted/zh-CN-ensaas-service-mesh-portal';
// import en_US_shared from './i18n/splitted/en-US-shared';
// import zh_TW_shared from './i18n/splitted/zh-TW-shared';
// import zh_CN_shared from './i18n/splitted/zh-CN-shared';
import { IntlProvider } from "react-intl";
import NamespacesList from "./pages/namespaces-list/namespaces-list";
import workspaceOverview from "./pages/workspace-overview/workspace-overview";
import ClusterOverview from "./pages/clusters/cluster-overview";
import workloadList from "./pages/workload-list/workload-list";
import User from "./pages/user/user";
import { UserManagement } from "./pages/user-management/user-management";
import { UserProfileEdit } from "./pages/user-profile-edit/user-profile-edit";
import { UsersProfileAdd } from "./pages/users-profile-add/users-profile-add";
import { UsersProfileDelete } from "./pages/users-profile-delete/users-profile-delete";
import { IUserInfoType, UserInfoContext } from "./contexts/user-info";
import UserInfo from "./components/user-info/user-info";
import { LangContext } from "./contexts/lang";
import Login from "./pages/login/login";
import { LOGIN_URL } from "./pages/login/login-util";
import { SignIn } from "./pages/login/sign-in";
import { ForgotPwd } from "./pages/login/forgot-pwd";
import { ResetPwd } from "./pages/login/reset-pwd";
import { ChangePwd } from "./pages/login/change-pwd";
import { ResendEmail } from "./pages/login/resend-email";
import OperationRecord from "./pages/operation-record/operation-record";
import NotFound from "./pages/not-found/not-found";
import { log_out } from './components/top-navbar/top-navbar';
import { SettingParamsContext } from './contexts/setting_params';
import { Register } from "./pages/login/register";
import { License } from "./pages/login/license";
import PodRestartAlarm from "./pages/pod-restart-alarm/pod-restart-alarm";
import { wise_iot_suite_logo } from './img';

import InstanceList from './pages/service/instance-list/instance-list';
import CreateSecret from './pages/service/create-secret/create-secret';
import BackUp from './pages/service/backup-restore/backup/backup';
import ServiceUsage from './pages/service/service-usage/service-usage';
import StorageSettings from './pages/service/backup-restore/storage-settings/storage-settings';
import BackupScheduler from './pages/service/backup-restore/backup-scheduler/backup-scheduler';
import Resource from './pages/service/resource/resource';
import ResourceOverview from './pages/service/resource/resource-overview';
import ResourceService from './pages/service/resource/resource-service';
import { worker_fetch } from "./worker/worker-fetch";
import {Version} from './app/enum/version.enum';

const AppContent: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  // 宣告所有變數和設置函數
  const { Content } = Layout,
    redirect_url: React.MutableRefObject<string> = useRef('/login/sign-in'),
    log_out_params = useRef({ log_out, redirect_url: redirect_url.current }),

    // [fly_in, set_fly_in]: [boolean, Dispatch<SetStateAction<boolean>>] = useContext(FlyInContext),
    lang: any = useContext(LangContext)[0],
    theme: string = useContext(ThemeContext)[0],
    [datacenter_name, set_datacenter_name]: [string, Dispatch<SetStateAction<string>>] = useState(''),
    set_multi_selected: React.Dispatch<React.SetStateAction<boolean[]>> = useContext(MultiSelectedContext)[1],
    set_button_hide: React.Dispatch<React.SetStateAction<boolean>> = useContext(ButtonHideContext)[1],
    [setting_params, set_setting_params]: [any, React.Dispatch<React.SetStateAction<any>>] = useContext(SettingParamsContext),
    [is_login, set_is_login] = useState(false),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    langs = useRef({
      'en-US': en_US,
      'zh-TW': zh_TW,
      'zh-CN': zh_CN
      // 'en-US': { ...en_US, ...en_US_shared, ...en_US_lite, ...en_US_service },
      // 'zh-TW': { ...zh_TW, ...zh_TW_shared, ...zh_TW_lite, ...zh_TW_service },
      // 'zh-CN': { ...zh_CN, ...zh_CN_shared, ...zh_CN_lite, ...zh_CN_service }
    } as { [key: string]: any }),
    cancel = (): void => {
      // if (fly_in) set_fly_in(false);

      set_multi_selected([]); // 若用滑鼠左鍵單選，就解除多選模式
      set_button_hide(false); // 若陣列中所有項目皆為false，button_hide狀態設為true，不顯示編輯刪除按鈕
    };

  useEffect((): void => {
    if (!sessionStorage.getItem("datacenter_name")) {
      (indexedDB as any).databases &&
        (indexedDB as any)
          .databases()
          .then((r: any) => {
            for (var i = 0; i < r.length; i++) window.indexedDB.deleteDatabase(r[i].name);
          })
          .then(() => {
            console.info("All indexedDB data cleared.");
          });
    }
  }, []);

  useEffect((): void => {
    set_is_login(window.location.pathname !== "/");
  }, [user_info.role]);

  const [validate_loading, set_validate_loading]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(true);

  useEffect(() => {
    if (!window.location.pathname?.includes('/login/sign-in')) {
      if (datacenter_name) {
        (async () => {
          try {
            set_validate_loading(true);
            const res: any = await fetch(
              `/v1/datacenter/${datacenter_name}/users/me?complete=true`,
              {
                method: 'GET',
                credentials: 'include',
                headers: {
                  'Content-Type': 'application/json'
                }
              }
            );
            const is_login: boolean = res?.status >= 200 && res?.status <= 299;
            if (is_login) {
              set_validate_loading(false);
              document.body.removeAttribute('class');
            } else {
              window.open('/login/sign-in', '_self');
              document.body.removeAttribute('class');
            }
          } catch (err) {
            console.error(err);
          }
        })()
      } else {
        (async () => {
          try {
            const res: any = await worker_fetch({ url: `/v1/datacentercode`, props });
            if (res?.data?.datacenterCode) set_datacenter_name(res.data.datacenterCode)
          } catch (err) {
            console.error(err);
          }
        })()
      }
    } else {
      set_validate_loading(false)
    }
    // eslint-disable-next-line
  }, [datacenter_name])


  // const [setting_params, set_setting_params] = useState({} as any);
  useEffect((): void => {
    worker_fetch({
      url: '/v4.0/params',
      props: {},
    }).then((res: any) => {
      set_setting_params({
        ...res.data,
        loginPageBackgroundImage: res.data.loginPageBackgroundImage
          ? `${res.data.loginPageBackgroundImage}?v=${Math.random()}`
          : '',
      })
    })
  }, [set_setting_params])

  const [bg_loading, set_bg_loading] = useState<boolean>(
    window.location.pathname.indexOf('login') !== -1,
  )
  useEffect(() => {
    if (Object.keys(setting_params).length > 0) {
      if (setting_params.loginPageBackgroundImage) {
        const img = new Image()
        img.src = setting_params.loginPageBackgroundImage
        img.onload = () => {
          set_bg_loading(false)
        }
      }
      set_bg_loading(false)
    }
  }, [setting_params])

  // const params = useContext(ParamsContext)[0];
  const login_methods = useMemo(() => {
    // const auth_arr = [{ key: '0', name: 'sso', auth_url: 'v4.0/auth' }, { key: '1', name: 'ldap', auth_url: 'v4.0/auth/ldap' }];
    const auth_arr = [{ key: '0', name: 'sso', auth_url: 'v4.0/auth' }, { key: '1', name: 'ldap', auth_url: 'v4.0/auth/ldap' }];
    return [auth_arr[0]];
  }, []);

  return (!validate_loading ?
    <IntlProvider locale={lang} messages={langs.current[lang]} onError={(err: any) => {
      if (err?.code === 'MISSING_TRANSLATION') {
        console.warn('Missing translation', err?.message);
        return;
      }
    }}
    >
      {(bg_loading) && <div className={'app_loading_loading'} />}
      <div className={`App ${theme}`} onClick={cancel}>
        <Layout>
          <Router>
            <UserInfo {...log_out_params.current} />
            <LeftMenu />
            <Content className={`${is_login ? "" : "login-content-box"} ant-col-sm-24`} style={{ overflowX: 'hidden', overflowY: 'auto', height: 'calc(100vh - 56px)', marginTop: '48px' }}>
              <Switch>
                <Route path={LOGIN_URL.licenseInvalid} component={License} />
                <Route
                  path="/login"
                  render={() => (
                    <Login lang={lang} setting_params={setting_params}>
                      <Route path={LOGIN_URL.signIn} render={(props: any) => <SignIn {...props} {...log_out_params.current} show_remember_me={true} show_forget_pwd={true} show_sign_up={true} login_methods={login_methods} logo_style={{backgroundImage: `url(${wise_iot_suite_logo})`, backgroundSize: "100% auto", backgroundPositionY: "center",}} setting_params={setting_params}/>} />
                      <Route path={LOGIN_URL.forgotPwd} render={(props: any) => <ForgotPwd {...props} {...log_out_params.current} />}/>
                      <Route path={LOGIN_URL.resetPwd} render={(props: any) => <ResetPwd {...props} {...log_out_params.current} />}/>
                      <Route path={LOGIN_URL.changePwd} render={(props: any) => <ChangePwd {...props} {...log_out_params.current} />}/>
                      <Route path={LOGIN_URL.resendEmail} render={(props: any) => <ResendEmail {...props} {...log_out_params.current} />}/>
                      <Route path={LOGIN_URL.register} render={(props: any) => <Register {...props} {...log_out_params.current} />}/>
                      <Redirect to={LOGIN_URL.signIn} />
                    </Login>
                  )}
                />
                <Route exact path="/" component={Global} />
                <Route path="/console" component={Global} />
                <Route path="/clusters" component={ClustersList} />
                <Route
                  path="/cluster-info"
                  render={() => (
                    <ClusterInfo>
                      <Route path="/cluster-info/overview" component={ClusterOverview} />
                      <Route path="/cluster-info/workspaces" component={WorkspacesList} />
                    </ClusterInfo>
                  )}
                />
                <Route
                  path="/workspace-info"
                  render={() => (
                    <WorkspaceInfo>
                      <Route path="/workspace-info/overview" component={workspaceOverview} />
                      <Route path="/workspace-info/namespaces" component={NamespacesList} />
                    </WorkspaceInfo>
                  )}
                />
                <Route
                  path="/namespace-info"
                  render={() => (
                    <NamespaceInfo>
                      <Route path="/namespace-info/overview" component={NamespaceOverview} />
                      <Route path="/namespace-info/workloads" component={workloadList} />
                    </NamespaceInfo>
                  )}
                />
                <Route
                  path="/quotas"
                  render={() => (
                    <QuotaManagement>
                      <Route path="/quotas/workspace-quotas" component={QuotaList} />
                      <Route path="/quotas/namespace-quotas" component={QuotaList} />
                    </QuotaManagement>
                  )}
                />
                <Route path="/workspace/scale" component={QuotaScale} />
                <Route path="/namespace/scale" component={QuotaScale} />
                <Route path="/workspace-quota/scale" component={QuotaScale} />
                <Route path="/namespace-quota/scale" component={QuotaScale} />
                <Route path="/alert-management" component={AlertManagement} />
                <Route
                  path="/monitor"
                  render={() => (
                    <MonitorManagement>
                      <Route path="/monitor/kubernetes" component={Monitor} />
                      <Route path="/monitor/service-usage" component={ServiceUsage} />
                    </MonitorManagement>
                  )}
                />
                <Route
                  path="/storage-info"
                  render={() => (
                    <StorageInfo>
                      <Route path="/storage-info/storage" component={StorageClass}/>
                      <Route path="/storage-info/pv" component={PV}/>
                      <Route path="/storage-info/pvc" component={PVC}/>
                    </StorageInfo>
                  )}
                />
                <Route path="/nodes" component={NodesManagement} />
                <Route path="/applications" component={Applications} />
                <Route path="/applications-detail" component={ApplicationsDetail} />
                <Route
                  path="/user"
                  render={() => (
                    <User>
                      <Route path="/user/management" component={UserManagement} />
                      <Route path="/user/edit-profile" component={UserProfileEdit} />
                      <Route path="/user/addusers-profile" component={UsersProfileAdd} />
                      <Route path="/user/deleteusers-profile" component={UsersProfileDelete} />
                    </User>
                  )}
                />
                <Route
                  path="/ingress-info"
                  render={() => (
                    <IngressInfo>
                      <Route path="/ingress-info/ingress" component={Ingress} />
                    </IngressInfo>
                  )}
                />
                <Route path="/records" component={OperationRecord} />
                <Route path="/restart-alarm" component={PodRestartAlarm} />
                <Route path={'/instance-list'} component={InstanceList} />
                <Route path={'/create-secret'} component={CreateSecret} />
                {(Version.mp_cloud as any === 'true'? user_info?.ssoRole === 'globalAdmin': true) && <Route path={'/service-backup-restore'} component={BackUp} />}
                {(Version.mp_cloud as any === 'true'? user_info?.ssoRole === 'globalAdmin': true) && <Route path="/storage-settings" component={StorageSettings} />}
                {(Version.mp_cloud as any === 'true'? user_info?.ssoRole === 'globalAdmin': true) && <Route path="/service-backup-scheduler" component={BackupScheduler} />}
                <Route
                  path="/resource"
                  render={() => (
                    <Resource>
                      <Route path="/resource/view" component={ResourceOverview} />
                      <Route path="/resource/service" component={ResourceService} />
                    </Resource>
                  )}
                />
                <Route component={NotFound} />
              </Switch>
            </Content>
          </Router>
        </Layout>
      </div>
    </IntlProvider> : <div className='app_loading'/>
  );
};

export default AppContent;